export default "__VITE_ASSET__Rb$CA_D9__"